import styled from "styled-components";

export const HomeStyled = styled.div`
  position: relative;
  width: 100%;
  min-height: 100vh;
  @media only screen and (max-width: 560px) {
    padding-top: 100px;
  }
`;

export const HomeContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 50px;

  @media only screen and (max-width: 560px) {
    flex-direction: column;
    padding: 0;
    padding-top: 50px;
    margin-bottom: 100px;
    height: auto;
  }
`;
export const Left = styled.div`
  flex: 0.5;

  @media only screen and (max-width: 560px) {
    padding: 20px;
    margin-bottom: 50px;
  }
  h2 {
    display: flex;
    font-size: 55px;
    margin-bottom: 20px;
    font-weight: 600;
    position: relative;
    letter-spacing: 8px;
    margin-bottom: 50px;

    span {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 200px;
      height: 2px;
      background: linear-gradient(90deg, #2196f3, transparent);
      @media only screen and (max-width: 560px) {
        left: 0;
        top: 0;
      }
    }
  }
  h4 {
    font-size: 30px;
    margin-bottom: 20px;
    font-weight: 400;
  }
`;
export const Right = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 0.5;

  @media only screen and (max-width: 560px) {
    justify-content: center;
  }
`;

export const PageLayout = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  padding-top: 100px;
  padding-bottom: 200px;
`;

export const SocialMedia = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
  flex-wrap: wrap;
`;
